import React from 'react';
import './cardr.css';
import AppStore from '../../assets/main/appstore.svg';
import Screen1 from '../../assets/cardr/screen1.png';
import Screen2 from '../../assets/cardr/screen2.png';

import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

const Cardr = () => {
  return (
    <section id='cardr'>
      <div className='container cardr__container_top'>
        <div className='cardr__container'>
          <div className='cardr__left'>
            <h1 className='noselect cardr__title'>Cardr</h1>
            <div className='cardr__content'>
              <p className='noselect'>
              Business card scanner for iPhone.
              </p>
              <p className='noselect'>
              Scan business cards and review every detail before saving to Contacts — or keep scans in the app. Cardr Pro adds batch scanning and CSV/vCard export. Everything is processed on your iPhone. No account. No subscription. No cloud.
              </p>
              <ul className='noselect cardr__features'>
                <li><strong>One tap, the whole card</strong> — not field-by-field.</li>
                <li><strong>Batch scanning</strong> — capture multiple cards in one session.</li>
                <li><strong>CSV and vCard export</strong> — export one scan or your history.</li>
                <li><strong>100% on-device</strong> — your cards never leave your phone.</li>
                <li><strong>Save your way</strong> — add to Contacts or keep in Cardr.</li>
                <li><strong>Private by design</strong> — no sign-up, no tracking, no servers.</li>
              </ul>
              <p className='noselect'>
                <a className='cardr__details-link' href='https://cardr.app/'>Learn more about Cardr, a business card scanner for iPhone</a>
              </p>
              <p className='noselect'>
                <a href='https://cardr.kmishukov.me/privacy/'>Cardr Privacy Policy</a>
              </p>
              <div className='noselect markov__buttons'>
                <a className='appstore_container' href='https://apps.apple.com/app/id6784471681' aria-label="Download Cardr on the App Store">
                  <img className='appstore' src={AppStore} alt="Download Cardr on the App Store" />
                </a>
              </div>
            </div>
          </div>
          <Swiper
            className='noselect cardr__screenshot'
            modules={[Pagination]}
            spaceBetween={40}
            slidesPerView={1}
            pagination={{ clickable: true, type: 'bullets' }}
          >
            <SwiperSlide><img src={Screen1} alt="Cardr scan history stored locally on an iPhone" /></SwiperSlide>
            <SwiperSlide><img src={Screen2} alt="Cardr scan result ready to add to iPhone Contacts" /></SwiperSlide>
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Cardr;
